/*
 * @Author: 刘枫
 * @Date: 2020-10-28 15:18:43
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-09-03 15:49:16
 */

<template>
  <div>
    <div class="header">
      <img
        src="../../assets/images/account_logo.png"
        width="200"
      >
    </div>
    <div class="cz-con">
      <div class="inner">
        <h2>我的账户</h2>
        <div
          class="myAccount"
          id="myAccount"
        >
          <table
            class="t-info t-infoh28"
            width=""
            cellspacing="0"
            cellpadding="0"
            border="0"
          >
            <tbody>
              <tr>
                <td
                  class="w03"
                  colspan="2"
                >
                </td>
              </tr>
              <tr>
                <td
                  class="content"
                  width=""
                >姓名/账号：{{account}}</td>
                <td
                  class="content"
                  width=""
                >级别：{{level}}</td>
              </tr>
              <tr>
                <td class="content">奖金积分: {{gold}}
                  <!-- <span class="m-l">
                    <a
                      class="btn"
                      @click="bonusCash"
                    >提现</a>
                  </span> -->
                  <!-- <span class="m-l">
                    <a
                      class="btn"
                      @click="showTransfer(transferType.gold,transferType.firstGold)"
                    >兑换</a>
                  </span> -->
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8888)"
                    >明细</a>
                  </span>
                </td>
                <td class="content">商家余额：{{netStoreIncomePoints}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="netStoreCash(netStoreIncomePoints, 4)"
                    >提现</a>
                  </span>
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8891)"
                    >明细</a>
                  </span>
                </td>
                <!-- <td class="content">红包积分:
                  {{redEnvelopeAmount}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8929)"
                    >明细</a>
                  </span>
                </td> -->
                <!-- <td class="content">冻奖金积分(分享粉丝)：{{frozenGold}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(13)"
                    >明细</a>
                  </span>
                </td> -->
                <!-- <td class="content">电子积分：{{electronicIntegral}}</td> -->
              </tr>
              <tr>

                <!-- <td class="content">冻奖金积分(分享粉丝)：{{frozenGold}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(13)"
                    >明细</a>
                  </span>
                </td> -->
                <td class="content">免费换购积分：{{redemption}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8916)"
                    >明细</a>
                  </span>

                </td>
                <td class="content">购物积分：{{generalMallIntegral}}
                  <!-- <span class="m-l">
                    <a
                      href="/showAlipay"
                      class="btn"
                    >充值</a>
                  </span> -->
                </td>
              </tr>
              <tr>

                <!-- <td class="content">红包积分:
                  {{redEnvelopeAmount}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8929)"
                    >明细</a>
                  </span>
                </td> -->
                <!-- <td class="content">冻奖金积分(消费全返)：{{returnAreaFrozenGold}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(14)"
                    >明细</a>
                  </span>
                </td> -->
              </tr>
              <tr>
                <td class="content">
                  自营购物积分：{{directlyMallIntegral}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8895)"
                    >明细</a>
                  </span>
                  <!-- <p class="overdue" v-if="overduePoints>0">{{overduePoints}}积分即将过期，有效期至{{overdueDate}}</p> -->
                </td>
                <td class="content">合伙人积分(配送):
                  <span class="m-l"> <a
                      href="/showConsumeConfirm"
                      class="btn"
                    >查看</a></span>
                </td>
                <!-- <td class="content">
                  消费全返专区累计金额(一级粉丝)：{{returnAreaRefererConsumeLeft}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8904)"
                    >明细</a>
                  </span>
                </td> -->
              </tr>
              <tr>
                <td class="content">现金券：{{coupon}}</td>
                <td class="content">自营订单累计:
                  {{selfEmployedTotal}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8980)"
                    >明细</a>
                  </span>
                </td>

              </tr>
              <tr>
                <td class="content">当月累计现金消费金额：{{currentConsume}}</td>
                <td
                  class="content"
                  v-if="firstBuyShow"
                >店长采购积分：{{firstBuy}}</td>
              </tr>
              <tr>
                <td
                  v-if="firstBuyShow"
                  class="content"
                >店长订单累计:
                  {{businessPurchaseTotal}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8917)"
                    >明细</a>
                  </span>
                </td>
                <td
                v-show="shoppingBonusFlag == 1 || (shoppingBonusFlag == 2 && +shoppingBonus > 0)"
                  class="content"
                >购物奖励积分:
                  {{shoppingBonus}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8601)"
                    >明细</a>
                  </span>
                </td>
              </tr>
              <tr>

                <td class="content">分享奖励：{{shareRewardsPoints}}
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="netStoreCash(shareRewardsPoints, 56)"
                    >提现</a>
                  </span>
                  <span class="m-l">
                    <a
                      class="btn"
                      @click="showItem(8830)"
                    >明细</a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import { getSession } from "utils/tool";
import { getMyPoint, getOverdue } from "api/user";
import { transferType } from "utils/constant";
import { H5_DEV_URL, H5_PRE_URL, H5_PRO_URL } from "utils/url";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      account: "",
      userName: "",
      // bonusPoints:'',
      gold: 0.0,
      goldProfitExcludeTax: 0.0,
      generalMallIntegral: "",
      happyShoppingPoint: "",
      directlyMallIntegral: "",
      overduePoints: 0, //
      overdueDate: "", //
      currentConsume: "",
      level: "",
      electronicIntegral: "",
      netStoreIncomePoints: "",
      coupon: "",
      frozenGold: 0,
      redemption: 0,
      firstBuy: "",
      // isFirstBuy: undefined,
      returnAreaFrozenGold: 0.0,
      returnAreaRefererConsumeLeft: 0.0,
      transferType: transferType,
      selfEmployedTotal: 0.0,
      businessPurchaseTotal: 0.0,
      h5Url: "",
      pointsTurn: "", // 网店开通积分互转地址
      incomeExchange: "", // 商家余额兑换地址
      turnpoints: 0, // 网店开通积分
      redEnvelopeAmount: 0, // 红包积分
      shareRewardsPoints: 0, // 分享奖励
      shoppingBonus: 0, // 购物奖励积分
      shoppingBonusFlag: null
    };
  },
  computed: {
    ...mapGetters(["isFirstBuy"]),
    firstBuyShow: {
      get() {
        return this.isFirstBuy == 1;
      },
    },
  },
  created() {
    if (location.hostname === "www.kxymall.com") {
      this.h5Url = H5_PRO_URL;
    } else if (location.hostname === "prepare.kxymall.com") {
      this.h5Url = H5_PRE_URL;
    } else {
      this.h5Url = H5_DEV_URL;
    }
    let loginName = getSession("userName");
    this.account = loginName;
    // let postBody = this.$Rsa.encrypt(JSON.stringify({ loginName: loginName }))
    getMyPoint({}).then((res) => {
      this.bonusPoints = res.data.gold;
      this.generalMallIntegral = res.data.shopMoney;
      this.happyShoppingPoint = res.data.happyShoppingPoint;
      this.directlyMallIntegral = res.data.signRebate;
      this.currentConsume = res.data.monthCash;
      this.level = res.data.memberLevel;
      this.netStoreIncomePoints = res.data.shopowner;
      this.coupon = res.data.coupon;
      this.electronicIntegral = res.data.electronicCurrency;
      this.frozenGold = res.data.frozenGold;
      this.redemption = res.data.redemption;
      this.firstBuy = res.data.firstBuy;
      this.turnpoints = res.data.openStore;
      this.redEnvelopeAmount = res.data.redEnvelopeAmount;
      // this.isFirstBuy = res.data.isFirstBuy;
      this.returnAreaFrozenGold = res.data.returnAreaFrozenGold;
      this.returnAreaRefererConsumeLeft = res.data.returnAreaRefererConsumeLeft;
      this.gold = res.data.gold;
      this.goldProfitExcludeTax = res.data.goldProfitExcludeTax;
      this.selfEmployedTotal = res.data.selfEmployedTotal;
      this.businessPurchaseTotal = res.data.businessPurchaseTotal;
      this.shareRewardsPoints = res.data.shareRewardsPoints;
      this.shoppingBonus = res.data.shoppingBonus
      this.shoppingBonusFlag = res.data.userDetailSwitchVO.shoppingBonus
      console.log(res.data, '---------------')
    });
    getOverdue({}).then((res) => {
      this.overduePoints = res.data.signRebate;
      this.overdueDate = res.data.signRebateExpiredDate;
    });
    this.pointsTurn =
      this.h5Url + `pointsExchange/pointsTurn?sid=${getSession("sid")}&page=PC`;
    this.incomeExchange =
      this.h5Url +
      `pointsExchange/incomeExchange?sid=${getSession("sid")}&page=PC`;
  },
  methods: {
    showTransfer(type1, type2) {
      let bonusPoints = 0;
      if (type1 === transferType.gold) {
        bonusPoints = this.bonusPoints;
      } else if (type1 === transferType.netStoreIncomePoints) {
        bonusPoints = this.netStoreIncomePoints;
      } else {
        layer.msg("兑换操作失败", { icon: 2 });
        return;
      }
      if (this.isFirstBuy == 1) {
        this.$router.push({
          path: "/showTransfer",
          query: {
            type1: type1,
            type2: type2,
            showTransfer: bonusPoints,
          },
        });
      } else {
        this.$router.push({
          path: "/showTransfer",
          query: {
            type1: type1,
            showTransfer: bonusPoints,
          },
        });
      }
    },
    bonusCash() {
      this.$router.push({
        path: "/bonusCash",
        query: {
          bonusValue: this.bonusPoints,
        },
      });
    },
    netStoreCash(value, type) {
      this.$router.push({
        path: "/netStoreCash",
        query: {
          value: value,
          type: type
        },
      });
    },
    showItem(type) {
      this.$router.push({
        path: "/point-item",
        query: {
          type: type,
        },
      });
    },
  },
};
</script>
<style lang="less">
@import "../../assets/css/account.less";
</style>



// WEBPACK FOOTER //
// index.vue?7a20cfc2